<svg viewBox="0 0 16 16" {...$$restProps} xmlns="http://www.w3.org/2000/svg">
  <path d="M14.03 8.015A6.017 6.017 0 008.015 2 6.017 6.017 0 002 8.015a6.02 6.02 0 004.812 5.895V9.82H5.609V8.015h1.203V6.511c0-1.16.944-2.105 2.105-2.105h1.504v1.805H9.218c-.33 0-.601.27-.601.601v1.203h1.804V9.82H8.617V14a6.014 6.014 0 005.413-5.985z"/>
</svg>
